import { Amplify } from 'aws-amplify';
import { fetchAuthSession, signIn, signOut, getCurrentUser } from 'aws-amplify/auth';
import { env } from './env';

let configured = false;

export function configureAmplify() {
  if (configured || env.mock) return;
  if (!env.cognitoUserPoolId || !env.cognitoClientId) return;
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.cognitoUserPoolId,
        userPoolClientId: env.cognitoClientId,
        loginWith: { email: true },
      },
    },
    ...(env.appsyncUrl
      ? {
          API: {
            GraphQL: {
              endpoint: env.appsyncUrl,
              region: env.appsyncRegion,
              defaultAuthMode: 'userPool' as const,
            },
          },
        }
      : {}),
  });
  configured = true;
}

// Backwards-compat alias for existing call sites.
export const configureAuth = configureAmplify;

export async function getIdToken(): Promise<string | null> {
  if (env.mock) return null;
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() ?? null;
  } catch {
    return null;
  }
}

export async function isSignedIn(): Promise<boolean> {
  if (env.mock) return true;
  try {
    await getCurrentUser();
    return true;
  } catch {
    return false;
  }
}

export { signIn, signOut, getCurrentUser };
